import { axios } from "../../helper/axios";
import { CoupanCityConstant } from "./CoupanCityConstant";

const CoupanCityApi = {};

CoupanCityApi.getCoupanCityApi = () => {
  return axios.get(CoupanCityConstant.COUPAN_CITY_API);
 
};

CoupanCityApi.postAddCoupanModel = (payload) => {
  return axios.post(CoupanCityConstant.POST_ADD_COUPAN_MODEL_API, payload);
};

//delete
CoupanCityApi.getCoupanCityDeleteApi = ({ id }) => {

  return axios.delete(`${CoupanCityConstant.COUPAN_CITY_DELETE_API}${id}`);
};

CoupanCityApi.getChargingNetworkDeleteApi = ({ id }) => {
  console.log(
    "charging network",
    CoupanCityConstant.CHARGING_NETWORK_DELETE_API
  );

  return axios.delete(
    ` ${CoupanCityConstant.CHARGING_NETWORK_DELETE_API}${id}`
  );
};

CoupanCityApi.getSelectCouponCityApi = () => {
  return axios.get(CoupanCityConstant.GET_SELECT_COUPON_CITY_API);
};

CoupanCityApi.getSelectChargingNetworkApi = () => {
  return axios.get(CoupanCityConstant.GET_SELECT_CHARGING_NETWORK_API);
};

export { CoupanCityApi };
